import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeferRenderingModule } from '../../directives/defer-rendering/defer-rendering.module';
import { IconicModule } from '../iconic/iconic.module';
import { ListModule } from '../list/list.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TreeListComponent, TreeListItemTemplate } from './tree-list.component';

const declarations = [TreeListComponent, TreeListItemTemplate];

@NgModule({
  imports: [
    CommonModule,
    IconicModule,
    ListModule,
    TooltipModule,
    DeferRenderingModule,
  ],
  declarations,
  exports: declarations,
})
export class TreeListModule {}
